import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Lock, LogOut, Check } from "lucide-react";

const PLANS = [
  { name: "Plus", features: ["50 pacientes", "30 análises de IA/mês", "20 teleconsultas/mês", "Transcrição e comparação por IA"] },
  { name: "Médico Profissional", features: ["300 pacientes", "150 análises de IA/mês", "100 teleconsultas/mês", "Todos os recursos de IA"], highlight: true },
  { name: "Premium", features: ["Pacientes ilimitados", "IA ilimitada", "Teleconsultas ilimitadas", "Prioridade no suporte"] },
];

export default function Paywall({ plan }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-secondary/30" data-testid="paywall">
      <div className="max-w-4xl w-full">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-destructive/10 flex items-center justify-center mx-auto mb-4">
            <Lock className="w-7 h-7 text-destructive" />
          </div>
          <h1 className="font-heading text-3xl font-light tracking-tighter">Período de avaliação terminou</h1>
          <p className="text-muted-foreground text-sm mt-2 max-w-lg mx-auto">
            Os seus 7 dias de teste chegaram ao fim. Para continuar a usar o LIA e aceder aos seus pacientes,
            escolha um plano. O valor mensal será informado em breve — fale com o administrador para ativar.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 mb-8">
          {PLANS.map((p) => (
            <Card key={p.name} className={`p-6 shadow-none ${p.highlight ? "border-ai ring-1 ring-ai/30" : "border-border"}`} data-testid={`paywall-plan-${p.name}`}>
              <h3 className="font-heading font-medium text-lg">{p.name}</h3>
              <ul className="mt-4 space-y-2">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-muted-foreground">
                    <Check className="w-4 h-4 text-success shrink-0 mt-0.5" /> {f}
                  </li>
                ))}
              </ul>
            </Card>
          ))}
        </div>

        <div className="flex justify-center gap-3">
          <Button variant="outline" onClick={async () => { await logout(); navigate("/login"); }} data-testid="paywall-logout-btn">
            <LogOut className="w-4 h-4 mr-2" /> Sair
          </Button>
        </div>
      </div>
    </div>
  );
}
